import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { AuthService } from './../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AlreadySignedInGuard implements CanActivate {

    constructor(private authService: AuthService, private router: Router) { }

    canActivate(activatedRoute: ActivatedRouteSnapshot, routerState: RouterStateSnapshot) {
      const signedIn = this.authService.isSignedIn();

      // console.log('AlreadySignedInGuard', signedIn);

      if (signedIn) {
        this.router.navigate(['/']);
        return false;
      } else {
        return true;
      }
    }
  }
